export const LOADER_STATUS = 'boilerplate/ITC04/Prepare/LOADER_STATUS';
export const ACTIVE_TAB = 'boilerplate/ITC04/Prepare/ACTIVE_TAB';
export const FILE_DATA = "boilderplate/ITC04/Prepare/FILE_DATA";
export const COMP_DATA = "boilderplate/ITC04/Analytics/COMP_DATA";
